<template>
  <section id="enterprise-live-map">
    <div v-if="getAddonFlag('GKMG_GRID_MAP')">
      <grid-menu-icon-button :isMobileDevice="isMobileDevice" />
    </div>
    <div v-if="getAddonFlag('GKMG_RADAR_GRID')">
      <rg-history-menu-button :isMobileDevice="isMobileDevice" />
    </div>
    <div v-if="isDebug">
      <debug-card :debugObject="debugObject" />
    </div>
    <div class="left-sidebar-details parentx-static">
      <vs-sidebar
        click-not-close
        hidden-background
        color="dark"
        class="items-no-padding"
        v-model="showVesselDetail"
      >
        <vessel-details />
      </vs-sidebar>

      <vs-sidebar
        click-not-close
        hidden-background
        color="dark"
        class="items-no-padding"
        v-model="showPlotDetail"
      >
        <plot-details />
      </vs-sidebar>

      <vs-sidebar
        v-if="getAddonFlag('GKMG_PRIVATE_PLOT')"
        click-not-close
        hidden-background
        color="dark"
        class="items-no-padding"
        v-model="showPrivatePlotDetail"
      >
        <private-plot-details />
      </vs-sidebar>

      <fixed-point-camera-sidebar />
    </div>

    <div
      class="map-controls-overlay"
      :class="{
        'is-not-open': isOpenMapControls,
        'weather-menu': showWeatherMenu || showContour,
      }"
    >
      <map-controls
        :map="map"
        :showWeatherMenu="showWeatherMenu"
        :showContour="showContour"
      >
      </map-controls>
    </div>

    <div
      id="map-controls-function"
      :class="{ 'weather-menu': showWeatherMenu || showContour }"
    >
      <a
        href="#"
        class="map-control-function-button cursor-pointer"
        @click.stop.prevent="onclickFunction"
      >
        <img :src="imageFunction" />
      </a>
    </div>

    <div class="map-controls-si">
      <map-controls-sidebar :map="map" />
    </div>

    <!--    <forecast-windy-detail-->
    <!--      :forecastDetailActive.sync="forecastDetailActive"-->
    <!--      :lngLat="lastClickedLngLat"-->
    <!--    ></forecast-windy-detail>-->

    <div id="movement-map">
      <plot-layer :is-ready="isStyleReady" :map="map" />
      <div v-if="getAddonFlag('GKMG_PRIVATE_PLOT')">
        <private-plot-layer
          :is-ready="isStyleReady"
          :map="map"
          :filterPrivatePlots="filterPrivatePlots"
        />
      </div>
      <vessel-map-layer
        :is-ready="isStyleReady"
        :map="map"
        :mapEvent="mapEvent"
      />
      <metocean-layer
        :is-ready="isStyleReady"
        :map="map"
        :mapEvent="mapEvent"
      />
      <contour-layer :is-ready="isStyleReady" :map="map" :mapEvent="mapEvent" />
      <vehicle-layer :is-ready="isStyleReady" :map="map" :mapEvent="mapEvent" />
      <typhoon-layer :is-ready="isStyleReady" :map="map" :mapEvent="mapEvent" />
      <traffic-routes-layer
        :is-ready="isStyleReady"
        :map="map"
        :mapEvent="mapEvent"
      />
      <navigational-aids-layer
        :is-ready="isStyleReady"
        :map="map"
        :mapEvent="mapEvent"
      />
      <fixed-point-cameras-layer
        :is-ready="isStyleReady"
        :map="map"
        :mapEvent="mapEvent"
      />
      <div v-if="getAddonFlag('GKMG_ANCHOR_MANAGEMENT')">
        <vessel-anchor-points-layer
          :is-ready="isStyleReady"
          :map="map"
          :mapEvent="mapEvent"
        />
      </div>
      <div v-if="getAddonFlag('GKMG_BASE_STATION')">
        <base-station-layer
          :is-ready="isStyleReady"
          :map="map"
          :mapEvent="mapEvent"
        />
        <!-- TODO: 使用する可能性があるのでコメントアウト。不要が確定したら削除する。 -->
        <!-- <destination-layer
          :is-ready="isStyleReady"
          :map="map"
          :mapEvent="mapEvent"
        /> -->
      </div>
      <div v-if="getAddonFlag('GKMG_RADAR_GRID')">
        <radar-grid-layer
          :is-ready="isStyleReady"
          :map="map"
          :mapEvent="mapEvent"
        />
      </div>
      <div id="map-loading" class="vs-con-loading__container"></div>
    </div>

    <div v-if="this.showWeatherMenu || showContour">
      <map-overlay-weather ref="mapOverlayWeather" />
    </div>

    <div
      v-if="this.showWeatherMenu"
      class="map-overlay-metocean-guide"
      @dblclick="$refs.mapOverlayWeather.resetWeatherTimeControllerPosition()"
      @touchstart.stop="touchMetoceanGuide('start')"
      @touchend.stop="touchMetoceanGuide('end')"
    >
      <img :src="metoceanGuideImg" />
    </div>

    <dialog-input-offing-wave-point />
    <popup-offing-wave-point-detail ref="popupOffingWavePointDetail" />

    <!-- LiveMap機能制限時のお問い合わせ促進表示エリア -->
    <div
      v-if="isFreeAccount"
      class="flex justify-between items-center map-restriction-info"
    >
      <div style="margin: 20px">
        <vs-icon icon="info" :color="AISEA_COLOR.BLUE" size="32px" />
      </div>
      <div style="margin: 20px 0">
        <span class="data-value aisea-text-16-400-black">
          現在マップは機能制限により東京湾のみ表示しています。機能制限を解除してご利用いただくためには別途有料版の契約が必要です。ご検討いただける場合、リンク先のお問い合わせフォームからご連絡ください。
        </span>
      </div>
      <div style="margin: 20px">
        <vs-button
          :color="AISEA_COLOR.PURE_WHITE"
          class="map-restriction-info-button"
          target
          :href="{ url: 'https://aisea.net/contact/' }"
          >お問い合わせフォーム</vs-button
        >
      </div>
    </div>
  </section>
</template>

<script>
import { createNamespacedHelpers, mapGetters } from "vuex";
import Mapbox from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import TileBelt from "@mapbox/tilebelt";
import QuadKeyTools from "quadkeytools";
import {
  MapSource,
  PlotMapSource,
  PrivatePlotMapSource,
} from "@/config/Map.js";
import LocalDbService from "@/services/localDbService";
import VesselMapLayer from "./layers/VesselMapLayer";
import PlotLayer from "./layers/PlotLayer";
import MetoceanLayer from "./layers/MetoceanLayer";
import VehicleLayer from "./layers/VehicleLayer";
import TyphoonLayer from "./layers/TyphoonLayer";
import ContourLayer from "./layers/ContourLayer";
import FixedPointCamerasLayer from "./layers/FixedPointCamerasLayer";
import NavigationalAidsLayer from "./layers/NavigationalAidsLayer";
import TrafficRoutesLayer from "./layers/TrafficRoutesLayer";
import MapControlsSidebar from "./components/sidebar/map-controls-sidebar/MapControlsSidebar";
import MapControls from "./components/map-controls/MapControls";
import RgHistoryMenuButton from "./components/buttons/RgHistoryMenuButton";
import VesselDetails from "./components/sidebar/vesselDetail/VesselDetail";
import PlotDetails from "./components/sidebar/plotDetail/PlotDetail";
import PrivatePlotDetails from "./components/sidebar/privatePlotDetail/PrivatePlotDetail";
import MapOverlayWeather from "./parts/MapOverlayWeather";
import DialogInputOffingWavePoint from "./components/dialogs/DialogInputOffingWavePoint";
import PopupOffingWavePointDetail from "./components/popups/popup-offing-wave-point-detail/PopupOffingWavePointDetail";
import FixedPointCameraSidebar from "./components/sidebar/fixed-point-camera-sidebar/FixedPointCameraSidebar";
import VesselAnchorPointsLayer from "@/components/organisms/VesselAnchorPointsLayer";
import BaseStationLayer from "@/components/organisms/BaseStationLayer";
import RadarGridLayer from "./layers/radar-grid/RadarGridLayer.vue";

// TODO: 使用する可能性があるのでコメントアウト。不要が確定したら削除する。
// import DestinationLayer from "@/components/organisms/DestinationLayer";
import PrivatePlotLayer from "@/components/organisms/PrivatePlotLayer";
import GridMenuIconButton from "@/components/atoms/GridMenuIconButton";
import DebugCard from "@/components/molecules/DebugCard";

import _ from "lodash";
import { db } from "@/firebase/firebaseConfig.js";
import * as turf from "@turf/turf";
import moment from "moment-timezone";
import Vue from "vue";
import ForecastWindyPopup from "./forecast-windy/ForecastWindyPopup";
import AuthService from "@/services/authService";
import { MAP_DEFAULT_POSITION } from "@/config/const";
import WebWorkerForFetchVesselGeometry from "worker-loader!@/utils/worker/WebWorkerForFetchVesselGeometry.js";
import WebWorkerForFetchVesselGeometryForSignal from "worker-loader!@/utils/worker/WebWorkerForFetchVesselGeometryForSignal.js";
import FireStoreService from "@/services/fireStoreService";

// Store
const {
  mapActions: mapActionsOfLiveMap,
  mapState: mapStateOfLiveMap,
  mapGetters: mapGettersOfLiveMap,
  mapMutations: mapMutationsOfLiveMap,
} = createNamespacedHelpers("liveMap");

const { mapActions: mapActionsOfPrivatePlot, mapState: mapStateOfPrivatePlot } =
  createNamespacedHelpers("gkmgPrivatePlot");

const {
  mapActions: mapActionsOfAnchor,
  mapState: mapStateOfAnchor,
  mapGetters: mapGettersOfAnchor,
} = createNamespacedHelpers("gkmgAnchor");

const {
  mapActions: mapActionsOfVesselEquipmentBaseStation,
  mapState: mapStateOfVesselEquipmentBaseStation,
} = createNamespacedHelpers("gkmgVesselEquipmentBaseStation");

// Mixins
import {
  LocalizeMixin,
  DeviceInfoMixin,
  LayerMixin,
  ColorMixin,
} from "@/mixins";

export default {
  name: "LiveMap",
  mixins: [LocalizeMixin, DeviceInfoMixin, LayerMixin, ColorMixin],
  components: {
    VesselMapLayer,
    PlotLayer,
    MapControlsSidebar,
    MapControls,
    VesselDetails,
    MapOverlayWeather,
    PlotDetails,
    PrivatePlotDetails,
    DialogInputOffingWavePoint,
    PopupOffingWavePointDetail,
    MetoceanLayer,
    VehicleLayer,
    TyphoonLayer,
    NavigationalAidsLayer,
    TrafficRoutesLayer,
    ContourLayer,
    FixedPointCamerasLayer,
    FixedPointCameraSidebar,
    VesselAnchorPointsLayer,
    BaseStationLayer,
    // DestinationLayer,  //TODO: 使用する可能性があるのでコメントアウト。不要が確定したら削除する。
    PrivatePlotLayer,
    GridMenuIconButton,
    RgHistoryMenuButton,
    RadarGridLayer,
    DebugCard,
  },
  data() {
    return {
      map: null,
      mapEvent: null,
      accessToken: process.env.VUE_APP_MAPBOX_TOKEN,
      zoom: 8,
      mapStyleLocal: null,

      isStyleReady: false,

      // Map life cycle
      updateVesselPositionsIntervalId: null,
      searchQuadKeys: [],

      // キャッシュ
      // timerMapMove: null,
      cache: {
        quadKey: null, // 同じQuadKeyエリアは表示しない用
        searchQuadKeys: [], // 検索QuadKey一覧
      },

      // Tab
      tabIndex: 0,
      storeUnsubscribe: null,
      doMapResize: false,
      // circleRadius: 400,

      // 沖波ポイント
      localOffingWavePoints: [],
      offingWavePointsMarkers: {},

      // Windy Forecast
      windyPopup: [],
      forecastDetailActive: false,
      lastClickedLngLat: {},

      isOpenMapControls: false,

      webWorker: null,
      intervalIdForGetFeatureCollection: [],
      intervalHistoryList: [],
      intervalIdForGetFeatureCollectionLong: [],
      timeoutIdForGetFeatureCollection: [],
      isReadyGetFeatureCollectionLong: false,
      isGettingFromVesselGeoInfoSummaryApi: false,
      featurePositionMap: new Map(),
      featureVectorMap: new Map(),
      featurePolygonMap: new Map(),

      touchMetoceanGuideStatus: null,
      // FireStoreのリッスン解放
      unsubscribes: [],
      // 時間経過によるプライベートプロットの監視
      intervalIdPrivatePlot: null,
      // デバッグ表示
      isDebug: false,
    };
  },
  computed: {
    ...mapStateOfLiveMap({
      ownVessels: (state) => state.ownVessels,
      selectedVessels: (state) => state.monitoringVessels,
      jumpTo: (state) => state.jumpTo,
      jumpToMap: (state) => state.jumpToMap,
      mapStyle: (state) => state.mapStyle,
      wakes: (state) => state.wakes,
      wakeLineFeatureCollection: (state) => state.wakeLineFeatureCollection,
      isNewSelectedVessel: (state) => state.isNewSelectedVessel,
      showWeatherMenu: (state) => state.showWeatherMenu,
      showContour: (state) => state.showContour,
      offingWavePoints: (state) => state.offingWavePoints,
      selectedMetoceanElement: (state) => state.selectedMetoceanElement,
      ownVesselDisplayDurationTime: (state) =>
        state.ownVesselDisplayDurationTime,
      filterPrivatePlots: (state) => state.filterPrivatePlots,
    }),
    ...mapStateOfPrivatePlot({
      privatePlots: (state) => state.privatePlots,
    }),
    ...mapStateOfAnchor({
      anchors: (state) => state.anchors,
    }),
    ...mapStateOfVesselEquipmentBaseStation({
      equipmentBaseStations: (state) => state.equipmentBaseStations,
    }),
    ...mapGettersOfLiveMap([
      "getOffingWavePointNextId",
      "isLimitOffingWavePoint",
      "getLastVesselPosition",
    ]),
    ...mapGettersOfAnchor(["getAnchorVesselIds"]),
    ...mapGetters({
      enterpriseVessels: "enterpriseVessel/getVessels",
      mapCenter: "enterpriseMapSetting/getCenter",
      plotFeaturesForPoint: "enterprisePlot/getFeaturesForPoint",
      plotFeaturesForPolygon: "enterprisePlot/getFeaturesForPolygon",
      privatePlotFeaturesForPoint:
        "gkmgPrivatePlot/getPrivatePlotFeaturesForPoint",
      privatePlotFeaturesForPolygon:
        "gkmgPrivatePlot/getPrivatePlotFeaturesForPolygon",
      showVesselDetail: "liveMap/showVesselDetail",
      showPlotDetail: "liveMap/showPlotDetail",
      showPrivatePlotDetail: "liveMap/showPrivatePlotDetail",
      getVesselNameFromWake: "liveMap/getVesselNameFromWake",
      getAddonFlag: "getAddonFlag",
    }),
    metoceanGuideImg() {
      if (this.selectedMetoceanElement === "oceanWind") {
        return require("@/assets/images/weather/guide_wind.svg");
      } else if (this.selectedMetoceanElement === "oceanWave") {
        return require("@/assets/images/weather/guide_wave.svg");
      } else {
        return require("@/assets/images/weather/guide_current.svg");
      }
    },
    imageFunction() {
      return this.isOpenMapControls
        ? require("@/assets/images/icons/sideber-menu/function.svg")
        : require("@/assets/images/icons/sideber-menu/function_opend.svg");
    },
    isFreeAccount() {
      return this.$store.state.isFree === true;
    },
    /** isDebugがtrueのときに表示する内容 */
    debugObject() {
      return {
        zoom: this.map ? this.map.getZoom() : "--",
      };
    },
    isMobileDevice() {
      // NOTE: 現状、ユーザエージェントでモバイル判定
      return ["iPhone", "iPad"].includes(this.getDeviceInfo().deviceType);
    },
  },
  watch: {
    jumpTo(newLocations) {
      this.map.jumpTo(newLocations);
      this.map.zoomTo(15);
    },
    jumpToMap(options) {
      this.map.jumpTo(options);
    },
    selectedVessels() {
      if (this.selectedVessels.length > 0) {
        this.tabIndex = 1;
      }
    },
    mapStyle(style) {
      if (this.map) {
        this.isStyleReady = false;
        this.map.setStyle(style);
        this.mapStyleLocal = style;
      }
    },
    /** パブリックプロット */
    plotFeaturesForPoint() {
      if (!this.map) return;
      const plotSource = this.map.getSource(PlotMapSource.PlotPointSource.id);
      if (plotSource != null) {
        plotSource.setData({
          type: "FeatureCollection",
          features: this.plotFeaturesForPoint,
        });
      }
    },
    plotFeaturesForPolygon() {
      if (!this.map) return;
      const plotSource = this.map.getSource(PlotMapSource.PlotPolygonSource.id);
      if (plotSource != null) {
        plotSource.setData({
          type: "FeatureCollection",
          features: this.plotFeaturesForPolygon,
        });
      }
    },
    privatePlots() {
      this.createPrivatePlotFeatures(this.privatePlots);
    },
    /** プライベートプロット(ポイント) */
    privatePlotFeaturesForPoint() {
      if (!this.getAddonFlag("GKMG_PRIVATE_PLOT")) return;
      if (!this.map) return;
      const privatePlotPointSource = this.map.getSource(
        PrivatePlotMapSource.PrivatePlotPointSource.id,
      );
      if (!privatePlotPointSource) return;
      privatePlotPointSource.setData({
        type: "FeatureCollection",
        features: this.privatePlotFeaturesForPoint,
      });
    },
    /** プライベートプロット(ポリゴン) */
    privatePlotFeaturesForPolygon() {
      if (!this.getAddonFlag("GKMG_PRIVATE_PLOT")) return;
      if (!this.map) return;
      const privatePlotPolygonSource = this.map.getSource(
        PrivatePlotMapSource.PrivatePlotPolygonSource.id,
      );
      if (!privatePlotPolygonSource) return;
      privatePlotPolygonSource.setData({
        type: "FeatureCollection",
        features: this.privatePlotFeaturesForPolygon,
      });
    },
    offingWavePoints(points) {
      if (points) {
        this.createOffingWavePointsMarkers(points);
      }
    },
    showWeatherMenu() {
      this.toggleClassMapCtrls();
    },
    showContour() {
      this.toggleClassMapCtrls();
    },
  },
  methods: {
    ...mapActionsOfLiveMap([
      "fetchCountryCode",
      "fetchOwnVessels",
      "fetchPolarisOffingWavePoint",
      "cleanUpVesselDetail",
      "cleanUpPlotDetail",
      "resetLiveMapState",
      "crateWakesLineFeature",
      "mergeWakes",
      "setIsNewSelectedVessel",
      "getTyphoonInfo",
    ]),
    ...mapActionsOfPrivatePlot([
      "fetchPrivatePlots",
      "removePrivatePlots",
      "createPrivatePlotFeatures",
      "resetPrivatePlotState",
    ]),
    ...mapActionsOfAnchor(["fetchAnchors", "removeAnchor", "resetAnchorState"]),
    ...mapActionsOfVesselEquipmentBaseStation([
      "fetchEquipmentBaseStations",
      "removeEquipmentBaseStations",
      "fetchEquipmentVessels",
      "removeEquipmentVessels",
      "fetchEquipmentCategories",
      "removeEquipmentCategories",
      "fetchEquipmentDepartureWharfs",
      "removeEquipmentDepartureWharfs",
      "fetchEquipmentDestinations",
      "removeEquipmentDestinations",
      "fetchEquipmentTypes",
      "removeEquipmentTypes",
      "fetchEquipmentSeaRoutes",
      "removeEquipmentSeaRoutes",
      "resetVesselEquipmentBaseStationState",
    ]),
    ...mapMutationsOfLiveMap([
      "SET_DIALOG_OFFING_WAVE_POINT_INPUT_FORM",
      "ADD_OFFING_WAVE_POINT",
    ]),

    mapLoaded() {
      if (this.getAddonFlag("GKMG_WEATHER_FORECAST")) {
        this.fetchPolarisOffingWavePoint();
        this.getTyphoonInfo();
      }
      this.setSubscribes();
      this.fetchData();
      // 他コンポーネントと座標とズームを同期できるようにする
      this.$store.dispatch(
        "enterpriseMapSetting/fetchZoom",
        this.map.getZoom(),
      );
      this.$store.dispatch(
        "enterpriseMapSetting/fetchCenter",
        this.map.getCenter(),
      );
    },
    async mapStyleLoad(_a, _b) {
      if (this.isDefaultMapStyle(this.mapStyleLocal)) {
        let lang = this.getBrowserLanguage();
        let local = "name_" + lang;
        if (this.map) {
          let textLayerIds = this.getTextLayerIds();
          textLayerIds.forEach((id) => {
            this.map.setLayoutProperty(id, "text-field", ["get", local]);
          });
        }
      }

      await this.setupMapSources();

      this.isStyleReady = true;
      this.cache.quadKey = null;

      this.cratePulsing(this.map);
      this.addAnimationIcon();

      this.updateMap(this);

      if (this.$route.params.plot_id) {
        this.$store
          .dispatch("enterprisePlot/getPlot", this.$route.params.plot_id)
          .then((data) => {
            const collections = data.plot_points.map((e) => {
              return turf.point([e.longitude, e.latitude]);
            });
            const features = turf.featureCollection(collections);
            const center = turf.center(features);
            // プロットの中心座標
            const coordinates = center.geometry.coordinates;
            this.map.flyTo({
              center: coordinates,
              zoom: 12,
            });
            this.$store.dispatch(
              "liveMap/showPlotDetail",
              this.$route.params.plot_id,
            );
          });
      }
      // プライベートプロットの場合
      if (this.$route.params.plot_hash) {
        const target = this.privatePlots.find(
          (plot) => plot.hash === this.$route.params.plot_hash,
        );
        this.map.flyTo({
          center: [target.center_point.longitude, target.center_point.latitude],
          zoom: 12,
        });
        this.$store.dispatch("liveMap/showPrivatePlotDetail", target);
      }

      if (this.getAddonFlag("GKMG_PRIVATE_PLOT")) {
        // 初回起動時だけプライベートプロットstoreを更新している
        // マップ起動時にwatch内のprivatePlotsが検知されずにgetSource()が取得できない可能性があるため
        const privatePlots = await FireStoreService.getPrivatePlots();
        privatePlots.forEach((privatePlot) => {
          this.fetchPrivatePlots(privatePlot);
        });
      }

      this.$vs.loading.close("#movement-map > .con-vs-loading");
    },
    mapMoveStart() {
      this.mapEvent = "mapMoveStart";
      this.unsubscribeFireStore();
    },
    mapMoveEnd() {
      this.$store.dispatch(
        "enterpriseMapSetting/fetchCenter",
        this.map.getCenter(),
      );
      this.updateMap(this);
    },
    mapZoomStart() {
      this.mapEvent = "mapZoomStart";
      this.unsubscribeFireStore();
    },
    mapZoomEnd() {
      this.mapEvent = "mapZoomEnd";
      this.$store.dispatch(
        "enterpriseMapSetting/fetchZoom",
        this.map.getZoom(),
      );
      this.updateMap(this);
    },
    mapPitch() {
      this.mapEvent = "mapPitch";
    },
    unsubscribeFireStore() {
      this.$vs.loading.close("#map-loading > .con-vs-loading");
      if (this.updateVesselPositionsIntervalId != null) {
        clearInterval(this.updateVesselPositionsIntervalId);
        this.updateVesselPositionsIntervalId = null;
      }
    },
    updateVesselPositions() {
      this.crateWakesLineFeature();
    },
    updateMap: _.debounce((self) => {
      if (self.map) {
        self.loadPlots(self.map);
        // QuadKeyArea更新
        if (self.fetchSearchQuadKeyArea()) {
          // unsubscribe
          self.unsubscribeFireStore();

          // 船舶描画
          self.updateVesselPositions();
          self.updateVesselPositionsIntervalId = setInterval(
            self.updateVesselPositions,
            5000,
          );
        }
        // FireStore監視
        self.setFeatureCollectionsFromApiWithInterval();
      }
    }, 1500),
    async setupMapSources() {
      /** 他社船 */
      this.map.addSource(MapSource.VesselPointSource.id, {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: [],
        },
      });

      this.map.addSource(MapSource.VesselVectorSource.id, {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: [],
        },
      });

      this.map.addSource(MapSource.VesselPolygonSource.id, {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: [],
        },
      });

      this.map.addSource(MapSource.VesselWakeLineSource.id, {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: [],
        },
      });

      this.map.addSource(MapSource.VesselWakeLineSourceForClickEvent.id, {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: [],
        },
      });

      /*=========================================================================================
         自社船 MapSource
        ==========================================================================================*/
      this.map.addSource(MapSource.OwnVesselPolygonSource.id, {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: [],
        },
      });

      this.map.addSource(MapSource.OwnVesselPointSource.id, {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: [],
        },
      });

      this.map.addSource(MapSource.OwnVesselMarkerSource.id, {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: [],
        },
      });

      /*=========================================================================================
         選択船 MapSource
        ==========================================================================================*/
      this.map.addSource(MapSource.SelectedVesselPolygonSource.id, {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: [],
        },
      });

      this.map.addSource(MapSource.SelectedVesselPointSource.id, {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: [],
        },
      });

      this.map.addSource(MapSource.SelectedVesselMarkerSource.id, {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: [],
        },
      });
      /*=========================================================================================
      基地局 MapSource
    ==========================================================================================*/
      this.map.addSource(MapSource.BaseStationSource.id, {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: [],
        },
      });
      /*=========================================================================================
      運搬先 MapSource
      TODO: 使用する可能性があるのでコメントアウト。不要が確定したら削除する。
    ==========================================================================================*/
      // this.map.addSource(MapSource.DestinationSource.id, {
      //   type: "geojson",
      //   data: {
      //     type: "FeatureCollection",
      //     features: [],
      //   },
      // });
      /*=========================================================================================
         アンカー船 MapSource
        ==========================================================================================*/
      this.map.addSource(MapSource.AnchorVesselPolygonSource.id, {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: [],
        },
      });

      this.map.addSource(MapSource.AnchorVesselPointSource.id, {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: [],
        },
      });

      this.map.addSource(MapSource.AnchorVesselMarkerSource.id, {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: [],
        },
      });

      /*=========================================================================================
         アンカー Anchor
       ==========================================================================================*/
      this.map.addSource(MapSource.AnchorPointSource.id, {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: [],
        },
      });
      this.map.addSource(MapSource.AnchorToVesselLineSource.id, {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: [],
        },
      });

      /*=========================================================================================
        パブリックプロット MapSource
       ==========================================================================================*/
      Object.values(PlotMapSource).forEach((source) => {
        this.map.addSource(source.id, {
          type: "geojson",
          data: {
            type: "FeatureCollection",
            features: [],
          },
        });
      });
      /*=========================================================================================
        プライベートプロット MapSource
       ==========================================================================================*/
      Object.values(PrivatePlotMapSource).forEach((source) => {
        this.map.addSource(source.id, {
          type: "geojson",
          data: {
            type: "FeatureCollection",
            features: [],
          },
        });
      });
    },

    addMapLayers() {
      this.map.addLayer({
        id: "polarisOffingWavePointSymbolLayer",
        type: "symbol",
        source: "polarisOffingWavePointSource",
      });
    },

    animation() {
      // アイコンが属するLayerのどれかをrepaintしてあげると他も追随してrepaintするようなので自社船のみ更新してみる
      this.map.setLayoutProperty(
        MapSource.OwnVesselPointSource.id,
        "icon-image",
        "pulsing",
      );
      requestAnimationFrame(this.animation);
    },

    addAnimationIcon() {
      //アニメーションアイコン表示
      this.map.addImage("pulsing", this.pulsing, { pixelRatio: 2 });

      //選択船
      this.map.addLayer({
        id: MapSource.SelectedVesselPointSource.id,
        type: "symbol",
        source: MapSource.SelectedVesselPointSource.id,
        maxzoom: 20,
        layout: {
          "icon-allow-overlap": true,
          "icon-ignore-placement": true,
          "icon-image": "pulsing",
        },
      });

      //自社船
      this.map.addLayer({
        id: MapSource.OwnVesselPointSource.id,
        type: "symbol",
        source: MapSource.OwnVesselPointSource.id,
        maxzoom: 20,
        layout: {
          "icon-allow-overlap": true,
          "icon-ignore-placement": true,
          "icon-image": "pulsing",
        },
      });

      requestAnimationFrame(this.animation);
    },

    /**
     * FireStore SnapShot範囲を生成
     *
     */
    fetchSearchQuadKeyArea() {
      let zoom = Math.floor(this.map.getZoom());
      zoom = zoom < 9 ? 9 : zoom;

      let tile = TileBelt.pointToTile(
        this.mapCenter.lng,
        this.mapCenter.lat,
        zoom,
      );
      let tile2 = TileBelt.pointToTile(
        this.mapCenter.lng,
        this.mapCenter.lat,
        zoom + 1,
      );
      let quadKey = TileBelt.tileToQuadkey(tile);
      //let childQuadKey = TileBelt.tileToQuadkey(tile2);
      let quadKeyPosition = TileBelt.tileToQuadkey(tile2) % 10;

      if (quadKey == this.cache.quadKey) {
        return false;
      }
      // reset
      this.cache.searchQuadKeys = [];

      let center = quadKey;
      switch (quadKeyPosition) {
        case 0: {
          let up = QuadKeyTools.sibling(center, "up");
          let upLeft = QuadKeyTools.sibling(up, "left");
          let left = QuadKeyTools.sibling(center, "left");
          this.cache.searchQuadKeys.push(up);
          this.cache.searchQuadKeys.push(upLeft);
          this.cache.searchQuadKeys.push(left);
          break;
        }
        case 1: {
          let right = QuadKeyTools.sibling(center, "right");
          let up = QuadKeyTools.sibling(center, "up");
          let upRight = QuadKeyTools.sibling(up, "right");
          this.cache.searchQuadKeys.push(right);
          this.cache.searchQuadKeys.push(up);
          this.cache.searchQuadKeys.push(upRight);
          break;
        }
        case 2: {
          let left = QuadKeyTools.sibling(center, "left");
          let down = QuadKeyTools.sibling(center, "down");
          let downLeft = QuadKeyTools.sibling(down, "left");
          this.cache.searchQuadKeys.push(left);
          this.cache.searchQuadKeys.push(down);
          this.cache.searchQuadKeys.push(downLeft);
          break;
        }
        case 3: {
          let right = QuadKeyTools.sibling(center, "right");
          let down = QuadKeyTools.sibling(center, "down");
          let downRight = QuadKeyTools.sibling(down, "right");
          this.cache.searchQuadKeys.push(right);
          this.cache.searchQuadKeys.push(down);
          this.cache.searchQuadKeys.push(downRight);
          break;
        }
        default: {
          break;
        }
      }

      this.cache.searchQuadKeys.push(center);
      this.cache.quadKey = quadKey;

      return true;
    },

    loadPlots(map) {
      let zoom = map.getZoom();
      if (zoom > 8) {
        let bbox = new Mapbox.LngLatBounds(
          map.getBounds().getSouthWest(),
          map.getBounds().getNorthEast(),
        );
        let poly = turf.bboxPolygon(bbox.toArray().flat());
        let factor = 1;

        if (zoom <= 10) {
          factor = 1;
        } else {
          // 拡大の場合は、画面外の領域も読み込み
          factor = zoom;
        }
        let scaledPoly = turf.transformScale(poly, factor);
        let northEast = scaledPoly.geometry.coordinates[0][2];
        let southWest = scaledPoly.geometry.coordinates[0][0];

        this.$store.dispatch("enterprisePlot/searchPlots", {
          plotChildCategoryIds: "",
          northEastLatitude: northEast[1],
          northEastLongitude: northEast[0],
          southWestLatitude: southWest[1],
          southWestLongitude: southWest[0],
        });
      }
    },

    fetchData() {
      this.fetchCountryCode();
      this.fetchOwnVessels();
    },

    afterAdjustDom() {
      let mbCtrlTopRightClass = document.getElementsByClassName(
        "mapboxgl-ctrl-top-right",
      );
      mbCtrlTopRightClass[0].childNodes[0].style.margin = "30px 10px 0 0";

      let navbarClass = document.getElementsByClassName("vx-navbar-wrapper");
      navbarClass[0].style.height = "60px";
    },

    getWorkerCount() {
      return navigator.hardwareConcurrency / 2 + 1;
    },

    setSubscribes() {
      this.storeUnsubscribe = this.$store.subscribe((mutation) => {
        if (!this.map) return;
        // 航跡データ変更イベントを監視
        if (mutation.type === "TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE") {
          if (this.map && !this.doMapResize) {
            this.doMapResize = true;
            setTimeout(() => {
              this.map.resize();
              this.doMapResize = false;
            }, 1000);
          }
          return;
        }
        // 航跡データ変更イベントを監視
        if (
          mutation.type === "liveMap/SET_WAKES" ||
          mutation.type === "liveMap/REMOVE_WAKE"
        ) {
          this.crateWakesLineFeature();
          return;
        }
        // 航跡GeoJson変更イベントを監視
        if (mutation.type === "liveMap/SET_WAKES_LINE_FEATURE_COLLECTION") {
          const source = this.map.getSource(MapSource.VesselWakeLineSource.id);
          if (source != null) {
            source.setData(this.wakeLineFeatureCollection);
          }
          const sourceForClickEvent = this.map.getSource(
            MapSource.VesselWakeLineSourceForClickEvent.id,
          );
          if (source != null) {
            sourceForClickEvent.setData(this.wakeLineFeatureCollection);
          }
          return;
        }

        /*=========================================================================================
           選択船位置変更イベント
          ==========================================================================================*/
        if (mutation.type === "liveMap/SET_SELECTED_VESSEL_POSITION") {
          // 新規追加の時だけ更新
          if (this.isNewSelectedVessel) {
            this.setIsNewSelectedVessel();
            this.updateVesselPositions();
          }
          return;
        }

        if (mutation.type === "liveMap/REMOVE_SELECTED_VESSEL_POSITION") {
          this.updateVesselPositions();
          return;
        }
      });
    },

    /**
     * 船舶位置情報群をタイミングをずらしながらAPI取得する.
     *
     * 以下の順番で非同期取得を開始.
     *
     * 1. map表示の中心座標を含む１辺20kmのタイルとその周辺＝合計９枚のタイルを取得開始.
     *      ---> 画面表示領域の真ん中あたりを先行して表示
     *
     * 2. 日本全域をカバーするタイルを取得開始. ( 暫定で Zoom:6 x 25枚のタイル に分割して並列取得)
     *      ---> 画面をZoom-outした時のために、あらかじめ周辺海域を含めた日本全域取得しておく
     *
     * 3. 画面に表示されている範囲をタイル分割して取得. 以降ポーリングで定期的に更新 (短周期).
     *      ---> 画面表示領域を常に更新 （Zoom値と画面解像度によるが、おおよそ 3x6 〜 5x7 枚のタイルを並列更新）
     *      ---> ユーザが Zoom変更(mapbox.zoomEnd) あるいは位置変更(mapbox.moveEnd)したら、画面表示領域の左上座標と右下座標を再計算＋ポーリング再実行
     *
     * 4. 日本全域をカバーする25枚のタイルをポーリングで定期的に更新 (長周期).
     *      ---> 日本全域の船舶位置が古くならない程度に最低限の更新
     *
     */
    setFeatureCollectionsFromApiWithInterval() {
      const japanAreaStartDelaySecond = 3; // 日本全体の取得の遅延開始時期(秒) おおむね表示範囲のFeatureCollectionを取得し終わった頃にスタート
      const japanAreaPollingSecond = 600; // 日本全体のポーリング間隔(秒)
      const nearAreaTileDelaySecond = 0.2; // 各タイルを並列取得する時の多重度を抑えるための時間差指定（画面表示領域）
      const japanAreaTileDelaySecond = 0.3; // 各タイルを並列取得する時の多重度を抑えるための時間差指定（日本全体）
      const cleanerPollingSecond = 60; // 指定時間以上経過している船舶は非表示にする処理のポーリング間隔(秒)

      const mapZoom = this.map.getZoom();
      const nearAreaPollingSecond = // 画面表示領域のポーリング間隔(秒)
        mapZoom >= 14
          ? 3 // zoom = 14 => scaleUnit = 200m ポリゴン表示開始サイズ
          : mapZoom >= 10
          ? 10 // zoom = 10 => scaleUnit = 3km 通常（初期表示サイズ）
          : mapZoom >= 9
          ? 3 * 60 // zoom =  9 => scaleUnit = 5km 船舶は○アイコン（東京湾全域程度）
          : mapZoom >= 5
          ? 10 * 60 // zoom =  5 => scaleUnit = 100km ほぼ日本全域
          : 10 * 60;

      if (this.intervalIdForGetFeatureCollection.length > 0) {
        // 短周期のインターバルがあればリセット（画面位置やZoom値が変わっているため）
        this.clearShortPolling([...this.intervalIdForGetFeatureCollection]);
        this.intervalIdForGetFeatureCollection.splice(0);
      }

      let tileZoom = 0;
      let tileDistanceFromCenter = 0;
      let tileList = [];

      // 初回： mapboxに表示された中心座標とそのzoom値に応じた9枚のパネルを取得. // １辺が約20km zoom=11 x 9枚で東京湾周辺が埋まる
      tileZoom = Math.floor(this.map.getZoom() > 11 ? 11 : this.map.getZoom()); // zoom-out を考慮して、ある程度zoomしたら、それより狭い範囲を取得しない
      tileDistanceFromCenter = 1;
      tileList = this.getTileListSquare(
        tileZoom,
        tileDistanceFromCenter,
        this.mapCenter,
      );
      this.setFeatureCollectionsFromApi(tileList, 0, null, "init-near");

      // ブラウザ枠に含まれるタイルをポーリング
      const intervalId = setInterval(() => {
        if (!this.checkPollingValidation("poll-near")) {
          return;
        }

        const currentZoom = Math.floor(this.map.getZoom());
        tileZoom = currentZoom > 10 ? 10 : currentZoom < 8 ? 8 : currentZoom;
        tileList = this.getTileListRectangle(
          tileZoom,
          this.map.getBounds().getNorthWest(),
          this.map.getBounds().getSouthEast(),
        );
        this.setFeatureCollectionsFromApi(
          tileList,
          nearAreaTileDelaySecond,
          null,
          "poll-near",
        );
      }, nearAreaPollingSecond * 1000);
      this.intervalIdForGetFeatureCollection.push({
        intervalId: intervalId,
        momentValue: moment().valueOf(),
      });

      if (!this.isReadyGetFeatureCollectionLong) {
        this.isReadyGetFeatureCollectionLong = true;

        // 日本全域を取得開始 （広域取得はページ初回表示時にポーリング開始したらページ消滅まで継続）
        setTimeout(() => {
          // 日本全域 : 初回
          tileZoom = 6;
          tileDistanceFromCenter = 2;
          const japanCenterLngLat = {
            lng: MAP_DEFAULT_POSITION.center[0],
            lat: MAP_DEFAULT_POSITION.center[1],
          };
          tileList = this.getTileListSquare(
            tileZoom,
            tileDistanceFromCenter,
            japanCenterLngLat,
          );
          this.setFeatureCollectionsFromApi(
            tileList,
            japanAreaTileDelaySecond,
            tileZoom,
            "init-japan",
          );

          // 日本全域 : ポーリング
          this.intervalIdForGetFeatureCollectionLong.push(
            setInterval(() => {
              if (!this.checkPollingValidation("poll-japan")) {
                return;
              }

              tileZoom = 8;
              tileDistanceFromCenter = 12;
              this.setFeatureCollectionsFromApi(
                tileList,
                japanAreaTileDelaySecond,
                tileZoom,
                "poll-japan",
              );
            }, japanAreaPollingSecond * 1000),
          );
        }, japanAreaStartDelaySecond * 1000);

        // 指定時間以上経過している船舶は非表示とするため、定期的にクリーナーを実行。
        this.intervalIdForGetFeatureCollectionLong.push(
          setInterval(() => {
            if (!this.checkPollingValidation("cleaner")) {
              return;
            }

            const ownVesselIds = this.ownVessels.map((x) => x.id);
            const anchorVesselIds = this.getAnchorVesselIds;
            const tenMinutesAgo = moment().subtract(10, "minutes").valueOf();
            const ownVesselDisplayDurationAgo = this
              .ownVesselDisplayDurationTime
              ? moment()
                  .subtract(this.ownVesselDisplayDurationTime, "minutes")
                  .valueOf()
              : 0;
            Array.from(this.featurePositionMap).forEach(
              ([vesselId, featureObj]) => {
                // 自社船： "自社船舶表示期限"の設定値以上経過している場合は表示しない。
                // 自社船以外の船：10分以上経過している場合は表示しない。
                // アンカー船は常に表示するため除外する
                if (anchorVesselIds.includes(vesselId)) return;
                if (
                  (ownVesselIds.includes(vesselId) &&
                    featureObj.properties.t < ownVesselDisplayDurationAgo) ||
                  (!ownVesselIds.includes(vesselId) &&
                    featureObj.properties.t < tenMinutesAgo)
                ) {
                  this.featurePositionMap.delete(vesselId);
                  this.featureVectorMap.delete(vesselId);
                  this.featurePolygonMap.delete(vesselId);
                }
              },
            );

            // メモリリーク対策。  頻繁に更新されるfeature***Mapのオブジェクトポインタを差し替えて、ガベージコレクションを促す。
            const featurePositionMapBackup = _.cloneDeep(
              this.featurePositionMap,
            );
            const featureVectorMapBackup = _.cloneDeep(this.featureVectorMap);
            const featurePolygonMapBackup = _.cloneDeep(this.featurePolygonMap);
            this.featurePositionMap = null;
            this.featureVectorMap = null;
            this.featurePolygonMap = null;
            this.featurePositionMap = featurePositionMapBackup;
            this.featureVectorMap = featureVectorMapBackup;
            this.featurePolygonMap = featurePolygonMapBackup;

            // vessel_geometryAPI取得に使っている setTimeout のタイマーIDも、古すぎるものはクリーニング。
            this.timeoutIdForGetFeatureCollection =
              this.timeoutIdForGetFeatureCollection.filter(
                (timeout) => timeout.t > tenMinutesAgo,
              );
          }, cleanerPollingSecond * 1000),
        );
      }

      // 参考数値：
      // zoom=11 x 9枚で東京湾周辺が埋まる（zoom=11 の場合、 日本緯度では１辺が約20km）
      // zoom=6 x 25枚で日本が埋まる。 全世界は zoom=6 x 64 x 64 でカバー ( 2^6 = 64 )
    },

    checkPollingValidation(keyName) {
      if (this.$route.name !== "enterprise-live-map") {
        // beforeDestroy() で削除しきれなかったポーリング処理を検知したら、終了処理をコール。
        Vue.$log.debug(
          `remained polling process has detected. So, destroy. (${keyName}) this.$route.name = `,
          this.$route.name,
        );
        this.destroyPolling();
        return false;
      }
      return true;
    },
    clearShortPolling(intervalList) {
      this.intervalHistoryList.push(intervalList);
      this.intervalHistoryList.forEach((intervalSet) => {
        intervalSet.forEach((intervalObj) =>
          clearInterval(intervalObj.intervalId),
        );
      });
    },
    destroyPolling() {
      this.webWorker.terminate();
      this.clearShortPolling([...this.intervalIdForGetFeatureCollection]);
      this.intervalIdForGetFeatureCollection = [];
      this.intervalIdForGetFeatureCollectionLong.forEach((interval) =>
        clearInterval(interval),
      );
      this.intervalIdForGetFeatureCollectionLong = [];
      this.timeoutIdForGetFeatureCollection.forEach((timeout) =>
        clearTimeout(timeout.timeoutId),
      );
      this.timeoutIdForGetFeatureCollection = [];
    },

    /**
     * 表示されたmapの左上緯度経度から右下緯度経度に含まれるタイル番号を算出する.
     */
    getTileListRectangle(tileZoom, northWestLngLat, southEastLngLat) {
      let northWestTile = TileBelt.pointToTile(
        northWestLngLat.lng,
        northWestLngLat.lat,
        tileZoom,
      );
      let souchEastTile = TileBelt.pointToTile(
        southEastLngLat.lng,
        southEastLngLat.lat,
        tileZoom,
      );

      const leftTileNumber = northWestTile[0] - 1;
      const rightTileNumber = souchEastTile[0] + 1;
      const topTileNumber = northWestTile[1] - 1;
      const bottomTileNumber = souchEastTile[1] + 1;

      return this.getTileList(
        tileZoom,
        topTileNumber,
        rightTileNumber,
        bottomTileNumber,
        leftTileNumber,
      );
    },

    /**
     * 表示されたmapの中心緯度経度とその周辺のタイル番号を算出する.
     */
    getTileListSquare(tileZoom, tileDistanceFromCenter, centerLngLat) {
      // tileDistanceFromCenter(normal):  0=1x1=1枚, 1=3x3=9枚, 2=5x5=25枚,

      // 地図の中央を含むタイル
      let centerTile = TileBelt.pointToTile(
        centerLngLat.lng,
        centerLngLat.lat,
        tileZoom,
      );

      const leftTileNumber = centerTile[0] - tileDistanceFromCenter;
      const rightTileNumber = centerTile[0] + tileDistanceFromCenter;
      const topTileNumber = centerTile[1] - tileDistanceFromCenter;
      const bottomTileNumber = centerTile[1] + tileDistanceFromCenter;

      const tileList = this.getTileList(
        tileZoom,
        topTileNumber,
        rightTileNumber,
        bottomTileNumber,
        leftTileNumber,
      );

      // 中心から渦巻き状に展開するように並べ替え
      const stepDirectionList = [
        [0, 1], // 下移動
        [-1, 0], // 左移動
        [0, -1], // 上移動
        [1, 0], // 右移動
      ];
      const centerX = Math.floor((leftTileNumber + rightTileNumber) / 2);
      const centerY = Math.floor((topTileNumber + bottomTileNumber) / 2);

      let tileListWork = Array.from(tileList);
      let stepIndex = 0;
      let tileListSpiral = [];
      let i = 0;

      let workX = centerX;
      let workY = centerY;
      let findIndex = tileListWork.findIndex(
        (tile) => tile[0] === workX && tile[1] === workY,
      );
      tileListSpiral.push(tileListWork[findIndex]);
      tileListWork.splice(findIndex, 1);

      while (tileListWork.length > 0 || i < 200) {
        let findIndex = tileListWork.findIndex(
          (tile) =>
            tile[0] === workX + stepDirectionList[stepIndex][0] &&
            tile[1] === workY + stepDirectionList[stepIndex][1],
        );
        if (findIndex >= 0) {
          tileListSpiral.push(tileListWork[findIndex]);
          tileListWork.splice(findIndex, 1);

          workX = workX + stepDirectionList[stepIndex][0];
          workY = workY + stepDirectionList[stepIndex][1];
          stepIndex = (stepIndex + 1) % stepDirectionList.length;
        } else {
          stepIndex =
            (stepIndex + stepDirectionList.length - 1) %
            stepDirectionList.length;
        }

        i = i + 1;
      }
      return tileListSpiral;
    },

    /**
     *  引数の指定範囲に従ったタイルリストを取得.
     */
    getTileList(
      tileZoom,
      topTileNumber,
      rightTileNumber,
      bottomTileNumber,
      leftTileNumber,
    ) {
      let tileList = [];
      for (let ry = topTileNumber; ry <= bottomTileNumber; ry++) {
        for (let rx = leftTileNumber; rx <= rightTileNumber; rx++) {
          tileList.push([rx, ry, tileZoom]);
        }
      }
      return tileList;
    },

    /**
     * 引数のタイルリスト毎にAPIをコールし、取得結果を既存のFeatureCollectionにマージして 該当のMapSourceにセット.
     *
     */
    setFeatureCollectionsFromApi(tileList, delaySecond, zoom, purpose) {
      Vue.$log.debug(
        moment().format("HH:mm:ss"),
        `setFeatureCollectionsFromApi() purpose = ${purpose}. tileList.length = ${tileList.length}`,
      );
      // zoomが4未満の場合はAPIを発行しない
      if (this.map.getZoom() < 4) {
        return;
      }
      // tile[2]（tileのzoom値）が0のときにquadkeyが空文字になるため除外する
      const newTileList = tileList.filter((tile) => tile[2] > 0);

      newTileList.forEach((tile, index) => {
        const timeoutId = setTimeout(async () => {
          try {
            const originalQuadKey = TileBelt.tileToQuadkey(tile); // そのタイルのquadKey番号
            const nextQuadKey = (parseInt(originalQuadKey, 4) + 1)
              .toString(4) // そのタイルの次のquadKey番号 (4進数計算)
              .padStart(originalQuadKey.length, "0"); // 0パディング

            let northWestQuadKey = originalQuadKey;
            let southEastQuadKey = nextQuadKey;

            const payload = {
              north_west_quad_key: northWestQuadKey,
              south_east_quad_key: southEastQuadKey,
              own_vessel_display_duration_minutes:
                this.ownVesselDisplayDurationTime,
              enterprise_vessel_ids: this.ownVessels.map((x) => x.id).join(","),
              selected_vessel_ids: this.selectedVessels
                .map((x) => x.id)
                .join(","),
              zoom: Math.floor(zoom || this.map.getZoom()),
            };

            await AuthService.getIdToken().then((idToken) => {
              // webWorkerで vessel_geometry取得APIをコール
              this.webWorker.postMessage({
                payload: payload,
                idToken: idToken,
              });
            });
          } catch (e) {
            Vue.$log.debug("setFeatureCollection failed. ", e);
          }
        }, delaySecond * index * 1000); // 引数のtileListの順番で処理できるように少しだけ時間をずらして取得.

        this.timeoutIdForGetFeatureCollection.push({
          timeoutId: timeoutId,
          t: moment().valueOf(),
        });
      });
    },

    async setVesselGeometryToMapSources(receivedData) {
      if (this.getAddonFlag("GKMG_ANCHOR_MANAGEMENT")) {
        await this.setAnchorVesselFeatureToMapBySource(
          receivedData.featureMapBySource,
          this,
        );
      }
      const featureMapBySource = receivedData.featureMapBySource;
      if (featureMapBySource && featureMapBySource.positions) {
        // featurePositionMapは LiveMap.vueのローカル変数。 e[0] は vessel_id. 頻繁な更新なのでmutationによる値保存は実施しない。
        Object.entries(featureMapBySource.positions).forEach(
          ([vesselId, featureObj]) => {
            this.featurePositionMap.set(vesselId, featureObj);
          },
        );
        Object.entries(featureMapBySource.vectors).forEach(
          ([vesselId, featureObj]) => {
            this.featureVectorMap.set(vesselId, featureObj);
          },
        );
        Object.entries(featureMapBySource.polygons).forEach(
          ([vesselId, featureObj]) => {
            this.featurePolygonMap.set(vesselId, featureObj);
          },
        );

        // mapboxへ setData
        this.setDataToMap(
          this.map,
          this.featurePositionMap,
          this.featureVectorMap,
          this.featurePolygonMap,
          this.ownVessels,
          this.selectedVessels,
          this.anchors,
          this.equipmentBaseStations,
          this.getAnchorVesselIds,
          this.getAddonFlag,
        );
        // 最新のposition情報を航跡としてアペンド(航跡表示をしたものだけ[最大５件])
        Object.values(featureMapBySource.positions)
          .filter((x) => x != null)
          .filter((x) => this.wakes.get(x.properties.id))
          .forEach((x) => {
            Vue.$log.debug("mergeWakes", x.geometry.coordinates, x.properties);
            this.mergeWakes({
              vesselId: x.properties.id,
              data: {
                id: x.properties.id,
                lat: x.geometry.coordinates[1],
                lon: x.geometry.coordinates[0],
                v: x.properties.v,
                t: x.properties.t,
              },
            });
          });
      }
    },

    setDataToMap: _.throttle(
      (
        map,
        featurePositionMap,
        featureVectorMap,
        featurePolygonMap,
        ownVessels,
        selectedVessels,
        anchors,
        equipmentBaseStations,
        anchorVesselIds,
        getAddonFlag,
      ) => {
        const ownVesselIds = ownVessels.map((x) => x.id);
        const selectedVesselIds = selectedVessels.map((x) => x.id);
        const positionFeatureList = Array.from(featurePositionMap.values());
        const vectorFeatureList = Array.from(featureVectorMap.values());
        const polygonFeatureList = Array.from(featurePolygonMap.values());

        // 他社船 position
        let otherVesselPointFeatureCollection = {
          type: "FeatureCollection",
          features: positionFeatureList
            .filter((x) => x != null)
            .filter((x) => !ownVesselIds.includes(x.properties.id))
            // アンカー船は取り除く
            .filter((x) => !anchorVesselIds.includes(x.properties.id)),
        };
        map
          .getSource(MapSource.VesselPointSource.id)
          .setData(otherVesselPointFeatureCollection);

        // 選択船 position
        let selectedVesselPointFeatureCollection = {
          type: "FeatureCollection",
          features: positionFeatureList
            .filter((x) => x != null)
            .filter((x) => selectedVesselIds.includes(x.properties.id))
            // アンカー船は取り除く
            .filter((x) => !anchorVesselIds.includes(x.properties.id)),
        };
        map
          .getSource(MapSource.SelectedVesselPointSource.id)
          .setData(selectedVesselPointFeatureCollection);
        map // 選択船はマーカーがある
          .getSource(MapSource.SelectedVesselMarkerSource.id)
          .setData(selectedVesselPointFeatureCollection);

        // 自社船 position
        let ownVesselPointFeatureCollection = {
          type: "FeatureCollection",
          features: positionFeatureList
            .filter((x) => x != null)
            .filter((x) => ownVesselIds.includes(x.properties.id))
            // アンカー船は取り除く
            .filter((x) => !anchorVesselIds.includes(x.properties.id)),
        };
        map
          .getSource(MapSource.OwnVesselPointSource.id)
          .setData(ownVesselPointFeatureCollection);
        map
          .getSource(MapSource.OwnVesselMarkerSource.id)
          .setData(ownVesselPointFeatureCollection);

        // アンカー船 position
        let anchorVesselPointFeatureCollection = {
          type: "FeatureCollection",
          features: positionFeatureList
            .filter((x) => x != null)
            // アンカー船
            .filter((x) => anchorVesselIds.includes(x.properties.id)),
        };
        map
          .getSource(MapSource.AnchorVesselPointSource.id)
          .setData(anchorVesselPointFeatureCollection);
        map
          .getSource(MapSource.AnchorVesselMarkerSource.id)
          .setData(anchorVesselPointFeatureCollection);

        // ベクトル表示
        let vesselFeatures = vectorFeatureList.map((x) => {
          return {
            type: "Feature",
            geometry: {
              type: "LineString",
              coordinates: [
                [
                  x.geometry.coordinates[0].coordinates[0],
                  x.geometry.coordinates[0].coordinates[1],
                ],
                [
                  x.geometry.coordinates[1].coordinates[0],
                  x.geometry.coordinates[1].coordinates[1],
                ],
              ],
            },
            properties: x.properties,
          };
        });
        let vesselVectorFeatureCollection = {
          type: "FeatureCollection",
          features: vesselFeatures,
        };
        map
          .getSource(MapSource.VesselVectorSource.id)
          .setData(vesselVectorFeatureCollection);

        // ポリゴン表示
        const polygonFeaturesWork = polygonFeatureList.flat();
        const polygonFeatures = polygonFeaturesWork.map((x) => {
          return {
            type: "Feature",
            geometry: {
              type: "Polygon",
              coordinates: [
                x.geometry.coordinates[0].map((x1) => x1.coordinates),
              ],
            },
            properties: x.properties,
          };
        });

        // ポリゴン (他社船)
        let otherVesselPolygonFeatureCollection = {
          type: "FeatureCollection",
          features: polygonFeatures
            .filter((x) => !ownVesselIds.includes(x.properties.id))
            .filter((x) => !selectedVesselIds.includes(x.properties.id))
            // アンカー船を取り除く
            .filter((x) => !anchorVesselIds.includes(x.properties.id)),
        };
        map
          .getSource(MapSource.VesselPolygonSource.id)
          .setData(otherVesselPolygonFeatureCollection);

        // ポリゴン (選択船)
        let selectedVesselPolygonFeatureCollection = {
          type: "FeatureCollection",
          features: polygonFeatures
            .filter((x) => selectedVesselIds.includes(x.properties.id))
            // アンカー船を取り除く
            .filter((x) => !anchorVesselIds.includes(x.properties.id)),
        };
        map
          .getSource(MapSource.SelectedVesselPolygonSource.id)
          .setData(selectedVesselPolygonFeatureCollection);

        // ポリゴン表示(自社船)
        let ownVesselPolygonFeatureCollection = {
          type: "FeatureCollection",
          features: polygonFeatures
            .filter((x) => ownVesselIds.includes(x.properties.id))
            // アンカー船を取り除く
            .filter((x) => !anchorVesselIds.includes(x.properties.id)),
        };
        map
          .getSource(MapSource.OwnVesselPolygonSource.id)
          .setData(ownVesselPolygonFeatureCollection);

        // ポリゴン表示(アンカー船)
        let anchorVesselPolygonFeatureCollection = {
          type: "FeatureCollection",
          features: polygonFeatures
            // アンカー船
            .filter((x) => anchorVesselIds.includes(x.properties.id)),
        };
        map
          .getSource(MapSource.AnchorVesselPolygonSource.id)
          .setData(anchorVesselPolygonFeatureCollection);

        // 自社船・選択船に紐づくアンカー
        // アンカーの中心位置を計算
        // 船本体のポリゴンがある場合はその0番目、ない場合はpointの緯度経度を中心計算に使用する
        const anchorVesselFeaturesForCalcCenter = [
          ...anchorVesselPolygonFeatureCollection.features,
          ...anchorVesselPointFeatureCollection.features,
        ].reduce((prev, feature) => {
          const vesselId = feature.properties && feature.properties.id;
          if (!Object.prototype.hasOwnProperty.call(prev, vesselId)) {
            prev[vesselId] = feature;
          }
          return prev;
        }, {});

        const anchorVesselCenterPoints = Object.keys(
          anchorVesselFeaturesForCalcCenter,
        ).reduce((prev, vesselId) => {
          const feature = anchorVesselFeaturesForCalcCenter[vesselId];
          if (Object.prototype.hasOwnProperty.call(prev, vesselId)) {
            return prev;
          }
          if (feature.geometry.type === "Polygon") {
            const collections = feature.geometry.coordinates[0].map((c) => {
              return turf.point(c);
            });
            const features = turf.featureCollection(collections);
            const centerFeature = turf.center(features);
            prev[vesselId] = centerFeature.geometry.coordinates;
          } else {
            prev[vesselId] = feature.geometry.coordinates;
          }
          return prev;
        }, {});

        /** アンカーのポイント */
        let anchorPointCollection = {
          type: "FeatureCollection",
          features: anchors.reduce((prev, anchor) => {
            const anchorVesselId = anchor.vessel_id;
            const feature = anchorVesselFeaturesForCalcCenter[anchorVesselId];
            const center = anchorVesselCenterPoints[anchorVesselId];
            anchor.points.forEach((point) => {
              let rotation = 0; // 回転角
              let distance = 0; // 距離
              let properties = {};
              if (feature && center) {
                // 回転角を求める
                rotation = turf.bearing(
                  [point.longitude, point.latitude],
                  [center[0], center[1]],
                );
                // 船舶とアンカーの距離を求める
                distance = turf.distance(
                  [point.longitude, point.latitude],
                  [center[0], center[1]],
                  { units: "kilometers" },
                );
                properties = feature.properties;
              }
              prev.push({
                geometry: {
                  coordinates: [point.longitude, point.latitude],
                  type: "Point",
                },
                properties: Object.assign({}, properties, anchor, {
                  r: rotation,
                  // 小数点第1位切り上げして単位をメートルに変換
                  d:
                    distance > 0 ? Math.ceil(distance * 1000 * 10) / 10 : "---",
                }),
                type: "Feature",
              });
            });
            return prev;
          }, []),
        };
        map
          .getSource(MapSource.AnchorPointSource.id)
          .setData(anchorPointCollection);
        /** アンカーと船舶を結ぶ線 */
        let anchorToVesselLineCollection = {
          type: "FeatureCollection",
          features: anchors.reduce((prev, anchor) => {
            const anchorVesselId = anchor.vessel_id;
            const feature = anchorVesselFeaturesForCalcCenter[anchorVesselId];
            const center = anchorVesselCenterPoints[anchorVesselId];
            // 船舶・中心座標が取れ、アンカーが存在する場合のみラインを描画する
            if (feature && center && anchor.points.length > 0) {
              anchor.points.forEach((point) => {
                prev.push({
                  geometry: {
                    coordinates: [
                      [center[0], center[1]],
                      [point.longitude, point.latitude],
                    ],
                    type: "LineString",
                  },
                  properties: Object.assign({}, feature.properties, anchor),
                  type: "Feature",
                });
              });
            }
            return prev;
          }, []),
        };
        map
          .getSource(MapSource.AnchorToVesselLineSource.id)
          .setData(anchorToVesselLineCollection);

        /** 基地局の座標 */
        if (getAddonFlag("GKMG_BASE_STATION")) {
          let baseStationFeatures = equipmentBaseStations.map((b) => {
            return {
              type: "Feature",
              geometry: {
                type: "Point",
                coordinates: [b.point.longitude, b.point.latitude],
              },
              properties: {},
            };
          });
          let baseStationFeatureCollection = {
            type: "FeatureCollection",
            features: baseStationFeatures,
          };
          map
            .getSource(MapSource.BaseStationSource.id)
            .setData(baseStationFeatureCollection);
        }

        /** 運搬先
         * TODO: 使用する可能性があるのでコメントアウト。不要が確定したら削除する。
         */
        // if (getAddonFlag("GKMG_BASE_STATION")) {
        //   const destinations = equipmentBaseStations.filter((base) => {
        //     return (
        //       base.category === EQUIPMENT_BASE_STATION_CATEGORY.DESTINATION
        //     );
        //   });
        //   let destinationFeatures = destinations.map((b) => {
        //     return {
        //       type: "Feature",
        //       geometry: {
        //         type: "Point",
        //         coordinates: [b.point.longitude, b.point.latitude],
        //       },
        //       properties: {},
        //     };
        //   });
        //   let destinationFeatureCollection = {
        //     type: "FeatureCollection",
        //     features: destinationFeatures,
        //   };
        //   map
        //     .getSource(MapSource.DestinationSource.id)
        //     .setData(destinationFeatureCollection);
        // }
      },
      800,
    ),

    addOffingWavePointsMarkers(point) {
      let el = document.createElement("div");
      let elId = `offing-wave-point-marker-${point.pointId}`;
      el.className = "offing-wave-point-marker";
      el.id = elId;
      let popup = new Mapbox.Popup({
        closeButton: false,
        closeOnClick: false,
        offset: [0, -30],
        anchor: "bottom",
        className: "offing-wave-point-marker-popup",
      }).setHTML(`<span>${point.pointName}</span>`);

      let marker = new Mapbox.Marker({
        element: el,
        draggable: false,
      })
        .setLngLat(point.coordinate)
        .setOffset([0, -15])
        .setPopup(popup)
        .addTo(this.map);
      let element = document.getElementById(elId);
      element.addEventListener("click", () => {
        marker.togglePopup(true);
        this.$refs.popupOffingWavePointDetail.show(point.pointId);
      });
      element.addEventListener("contextmenu", (e) => {
        e.stopPropagation();
      });

      let self = this;

      function onDragEnd() {
        let lngLat = marker.getLngLat();
        let el = marker.getElement();
        const idSplit = el.id.split("-");
        let pointId = Number(idSplit[idSplit.length - 1]);
        let point = self.localOffingWavePoints.find((v) => {
          return v.pointId === pointId;
        });
        self.SET_DIALOG_OFFING_WAVE_POINT_INPUT_FORM({
          isShow: true,
          inputValues: {
            pointName: `${point.pointName}`,
            lng: lngLat.lng,
            lat: lngLat.lat,
          },
          oldInputValues: {
            pointId: point.pointId,
            pointName: `${point.pointName}`,
            lng: point.coordinate[0],
            lat: point.coordinate[1],
          },
        });
      }

      marker.on("dragend", onDragEnd);

      marker.togglePopup(true);

      this.offingWavePointsMarkers[point.pointId] = marker;
    },

    removeOffingWavePointsMarkers(point) {
      let marker = this.offingWavePointsMarkers[point.pointId];
      marker.remove();
      delete this.offingWavePointsMarkers[point.pointId];
    },

    createOffingWavePointsMarkers(newPoints) {
      if (
        newPoints.length > this.localOffingWavePoints.length &&
        this.localOffingWavePoints.length === 0
      ) {
        newPoints.forEach((newPoint) => {
          this.addOffingWavePointsMarkers(newPoint);
        });
        this.localOffingWavePoints = _.cloneDeep(newPoints);
        return;
      }

      if (newPoints.length === 0) {
        this.localOffingWavePoints.forEach((point) => {
          this.removeOffingWavePointsMarkers(point);
        });
        this.localOffingWavePoints = _.cloneDeep(newPoints);
        return;
      }

      if (newPoints.length === this.localOffingWavePoints.length) {
        newPoints.forEach((newPoint) => {
          let index = this.localOffingWavePoints.findIndex(
            (localPoint) => localPoint.pointId === newPoint.pointId,
          );
          if (index !== -1) {
            this.removeOffingWavePointsMarkers(newPoint);
            this.addOffingWavePointsMarkers(newPoint);
          }
        });
        this.localOffingWavePoints = _.cloneDeep(newPoints);
        return;
      }

      if (newPoints.length < this.localOffingWavePoints.length) {
        this.localOffingWavePoints.forEach((point) => {
          this.removeOffingWavePointsMarkers(point);
        });
        newPoints.forEach((newPoint) => {
          this.addOffingWavePointsMarkers(newPoint);
        });
        this.localOffingWavePoints = _.cloneDeep(newPoints);
        return;
      }

      this.localOffingWavePoints.forEach((localPoint) => {
        let index = newPoints.findIndex(
          (newPoint) => newPoint.pointId === localPoint.pointId,
        );
        if (index === -1) {
          this.removeOffingWavePointsMarkers(localPoint);
        }
      });

      newPoints.forEach((newPoint) => {
        if (this.localOffingWavePoints.length !== 0) {
          let index = this.localOffingWavePoints.findIndex(
            (localPoint) => localPoint.pointId === newPoint.pointId,
          );
          if (index === -1) {
            this.addOffingWavePointsMarkers(newPoint);
          }
        } else {
          this.addOffingWavePointsMarkers(newPoint);
        }
      });

      this.localOffingWavePoints = _.cloneDeep(newPoints);
    },

    onclickFunction() {
      this.isOpenMapControls = !this.isOpenMapControls;
    },
    toggleClassMapCtrls() {
      const mapCtrlSelectors = ".mapboxgl-ctrl-bottom-left";
      const mapCtrls = document.querySelectorAll(mapCtrlSelectors);
      mapCtrls.forEach((mapCtrl) => {
        mapCtrl.classList.toggle(
          "weather-menu",
          this.showWeatherMenu || this.showContour,
        );
      });
    },
    cratePulsing(_) {
      let size = 150;
      this.pulsing = {
        width: size,
        height: size,
        data: new Uint8Array(size * size * 4),
        onAdd: function () {
          let canvas = document.createElement("canvas");
          canvas.width = this.width;
          canvas.height = this.height;
          this.context = canvas.getContext("2d");
        },

        render: function () {
          let duration = 2000;
          let t = (performance.now() % duration) / duration;

          let radius = (size / 2) * 0.3;
          let outerRadius = (size / 2) * 0.7 * t + radius;
          let context = this.context;

          context.clearRect(0, 0, this.width, this.height);
          context.beginPath();
          context.arc(
            this.width / 2,
            this.height / 2,
            outerRadius,
            0,
            Math.PI * 2,
          );
          context.fillStyle = "rgba(255, 255, 255," + (1 - t) + ")";
          context.fill();

          this.data = context.getImageData(0, 0, this.width, this.height).data;

          return true;
        },
      };
    },

    touchMetoceanGuide(type) {
      if (type === "start") {
        if (!this.touchMetoceanGuideStatus) {
          this.touchMetoceanGuideStatus = "start";
          setTimeout(() => {
            this.touchMetoceanGuideStatus = null;
          }, 300);
        } else if (this.touchMetoceanGuideStatus === "end") {
          this.$refs.mapOverlayWeather.resetWeatherTimeControllerPosition();
        }
      } else {
        this.touchMetoceanGuideStatus = "end";
        setTimeout(() => {
          this.touchMetoceanGuideStatus = null;
        }, 300);
      }
    },
    /**
     * アンカーのスナップショットを取得
     */
    async onSnapshotAnchors(enterpriseId) {
      let query = db.collection("gkmg_vessel_anchor_points");
      query = query.where("deleted_at", "==", null);
      // 法人IDで絞り込む
      query = query.where("enterprise_id", "==", enterpriseId);
      let unsubscribe = await query.onSnapshot(
        (snapshot) => {
          // 取得結果が0件のときにアンカーが更新されるようにするための対応
          if (snapshot.size === 0) {
            this.fetchAnchors(null);
            return;
          }
          snapshot.docChanges().forEach((change) => {
            if (change.doc.data() !== undefined) {
              if (change.type === "removed") {
                this.removeAnchor(change.doc.id);
              } else {
                this.fetchAnchors({
                  ...change.doc.data(),
                  hash: change.doc.id,
                });
              }
            }
          });
        },
        function (_) {},
      );
      this.unsubscribes.push(unsubscribe);
    },
    /**
     * 拠点のスナップショットを取得
     */
    async subscribeEquipmentBaseStations() {
      let unsubscribe = await db
        .collection("gkmg_equipment_base_stations")
        .onSnapshot(
          (snapshot) => {
            if (snapshot.size === 0) {
              this.fetchEquipmentBaseStations(null);
              return;
            }
            snapshot.docChanges().forEach(async (change) => {
              if (change.doc.data() !== undefined) {
                if (change.type === "removed") {
                  this.removeEquipmentBaseStations(change.doc.id);
                } else {
                  const baseRecord = await change.doc.ref
                    .collection("data")
                    .get();
                  this.fetchEquipmentBaseStations({
                    ...change.doc.data(),
                    hash: change.doc.id,
                    data: baseRecord.docs.map((doc) => {
                      return {
                        ...doc.data(),
                        hash: doc.id,
                      };
                    }),
                  });
                }
              }
            });
          },
          function (_) {},
        );
      this.unsubscribes.push(unsubscribe);
    },
    /**
     * 資機材船舶のスナップショットを取得
     */
    async subscribeEquipmentVessels() {
      let unsubscribe = await db
        .collection("gkmg_equipment_vessels")
        .onSnapshot(
          (snapshot) => {
            if (snapshot.size === 0) {
              this.fetchEquipmentVessels(null);
              return;
            }
            snapshot.docChanges().forEach(async (change) => {
              if (change.doc.data() !== undefined) {
                if (change.type === "removed") {
                  this.removeEquipmentVessels(change.doc.id);
                } else {
                  const vesselRecord = await change.doc.ref
                    .collection("data")
                    .limit(1)
                    .get();
                  // vesselRecord.sizeが0になる場合があるのでvesselRecord.sizeが存在する場合に実行する。
                  if (vesselRecord.size) {
                    this.fetchEquipmentVessels({
                      ...change.doc.data(),
                      hash: change.doc.id,
                      data: vesselRecord.docs[0].data(),
                    });
                  }
                }
              }
            });
          },
          function (_) {},
        );
      this.unsubscribes.push(unsubscribe);
    },
    /**
     * 資機材カテゴリマスタのスナップショットを取得
     */
    async subscribeEquipmentCategories() {
      let unsubscribe = await db
        .collection("gkmg_equipment_categories")
        .onSnapshot(
          (snapshot) => {
            if (snapshot.size === 0) {
              this.fetchEquipmentCategories(null);
              return;
            }
            snapshot.docChanges().forEach((change) => {
              if (change.doc.data() !== undefined) {
                if (change.type === "removed") {
                  this.removeEquipmentCategories(change.doc.id);
                } else {
                  this.fetchEquipmentCategories({
                    ...change.doc.data(),
                    hash: change.doc.id,
                  });
                }
              }
            });
          },
          function (_) {},
        );
      this.unsubscribes.push(unsubscribe);
    },
    /**
     * 出発岸壁マスタのスナップショットを取得
     */
    async subscribeEquipmentDepartureWharfs() {
      let unsubscribe = await db
        .collection("gkmg_equipment_departure_wharfs")
        .onSnapshot(
          (snapshot) => {
            if (snapshot.size === 0) {
              this.fetchEquipmentDepartureWharfs(null);
              return;
            }
            snapshot.docChanges().forEach((change) => {
              if (change.doc.data() !== undefined) {
                if (change.type === "removed") {
                  this.removeEquipmentDepartureWharfs(change.doc.id);
                } else {
                  this.fetchEquipmentDepartureWharfs({
                    ...change.doc.data(),
                    hash: change.doc.id,
                  });
                }
              }
            });
          },
          function (_) {},
        );
      this.unsubscribes.push(unsubscribe);
    },
    /**
     * 目的地マスタのスナップショットを取得
     */
    async subscribeEquipmentDestinations() {
      let unsubscribe = await db
        .collection("gkmg_equipment_destinations")
        .onSnapshot(
          (snapshot) => {
            if (snapshot.size === 0) {
              this.fetchEquipmentDestinations(null);
              return;
            }
            snapshot.docChanges().forEach((change) => {
              if (change.doc.data() !== undefined) {
                if (change.type === "removed") {
                  this.removeEquipmentDestinations(change.doc.id);
                } else {
                  this.fetchEquipmentDestinations({
                    ...change.doc.data(),
                    hash: change.doc.id,
                  });
                }
              }
            });
          },
          function (_) {},
        );
      this.unsubscribes.push(unsubscribe);
    },
    /**
     * 投入実績のスナップショットを取得
     */
    async subscribeEquipmentTypes() {
      let unsubscribe = await db.collection("gkmg_equipment_types").onSnapshot(
        (snapshot) => {
          if (snapshot.size === 0) {
            this.fetchEquipmentTypes(null);
            return;
          }
          snapshot.docChanges().forEach(async (change) => {
            if (change.doc.data() !== undefined) {
              if (change.type === "removed") {
                this.removeEquipmentTypes(change.doc.id);
              } else {
                const trackRecord = await change.doc.ref
                  .collection("data")
                  .limit(1)
                  .get();
                this.fetchEquipmentTypes({
                  ...change.doc.data(),
                  hash: change.doc.id,
                  data:
                    trackRecord.size === 0 ? null : trackRecord.docs[0].data(),
                });
              }
            }
          });
        },
        function (_) {},
      );
      this.unsubscribes.push(unsubscribe);
    },
    /**
     * 運搬航路マスタのスナップショットを取得
     */
    async subscribeEquipmentSeaRoutes() {
      let unsubscribe = await db.collection("gkmg_sea_routes").onSnapshot(
        (snapshot) => {
          if (snapshot.size === 0) {
            this.fetchEquipmentSeaRoutes(null);
            return;
          }
          snapshot.docChanges().forEach(async (change) => {
            if (change.doc.data() !== undefined) {
              if (change.type === "removed") {
                this.removeEquipmentSeaRoutes(change.doc.id);
              } else {
                const baseRecord = await change.doc.ref
                  .collection("data")
                  .get();
                this.fetchEquipmentSeaRoutes({
                  ...change.doc.data(),
                  hash: change.doc.id,
                  data: baseRecord.docs.map((doc) => {
                    return {
                      ...doc.data(),
                      hash: doc.id,
                    };
                  }),
                });
              }
            }
          });
        },
        function (_) {},
      );
      this.unsubscribes.push(unsubscribe);
    },
    /**
     * プライベートプロットのスナップショットを取得
     */
    async onSnapshotPrivatePlots() {
      let unsubscribe = await db
        .collection("gkmg_private_plots")
        .where("deleted_at", "==", null)
        .onSnapshot(
          (snapshot) => {
            // 取得結果が0件のときにプライベートプロットが更新されるようにするための対応
            if (snapshot.size === 0) {
              this.fetchPrivatePlots(null);
              return;
            }
            snapshot.docChanges().forEach((change) => {
              if (change.doc.data() !== undefined) {
                // データをセットする際に、ハッシュ値が含まれるようにする。
                const param = {
                  ...change.doc.data(),
                  hash: change.doc.id,
                };
                if (change.type === "removed") {
                  this.removePrivatePlots(param);
                } else {
                  this.fetchPrivatePlots(param);
                }
              }
            });
          },
          function (_) {},
        );
      this.unsubscribes.push(unsubscribe);
    },

    // WARNING: 副作用あり -> featureMapBySourceのプロパティを更新する
    setAnchorVesselFeatureToMapBySource: _.throttle(
      async (featureMapBySource, self) => {
        Vue.$log.debug(
          `start setAnchorVesselFeatureToMapBySource.`,
          self.$route.name,
          // self.mapId // NOTE: グリッドの場合にどのマップで呼ばれているか確認する
        );
        await Promise.allSettled(
          self.getAnchorVesselIds.map(async (anchorVesselId) => {
            // featureMapBySourceにanchorVesselIdがない場合は右メニュークリック時に取得した lastPosition のデータを画面描画に使用
            if (
              !featureMapBySource.positions[Number(anchorVesselId)] &&
              !self.featurePositionMap.has(anchorVesselId)
            ) {
              const vessel = self.getLastVesselPosition(anchorVesselId);
              // lastPositionからも取得できなかった船舶は右メニューに表示できない
              // [INFO] 対象の船舶がないとき(undefined or error_code=300 or status=500となる)
              if (
                !vessel ||
                vessel.error_code === 300 ||
                vessel.status === 500
              ) {
                return;
              }
              featureMapBySource.positions[Number(vessel.vessel_id)] = {
                geometry: {
                  coordinates: [vessel.longitude, vessel.latitude],
                  type: "Point",
                },
                properties: {
                  n: vessel.vessel_name_ja || vessel.vessel_name,
                  id: vessel.vessel_id,
                },
                type: "Feature",
              };
            }
          }),
        );
      },
      1000,
    ),
  },

  /** Windyポップアップを生成する */
  openWindyPopup(e) {
    // 初期化
    this.clearWindyPopup();
    this.forecastDetailActive = false;
    this.lastClickedLngLat = e.lngLat;

    // Vueコンポーネントを後付けで動的生成
    var ForecastPopupClass = Vue.extend(ForecastWindyPopup);
    var instance = new ForecastPopupClass({
      // 追加
      propsData: {
        lngLat: e.lngLat,
      },
    });
    instance.parent = this;
    instance.$on("emit-show-forecast-detail", function () {
      instance.parent.showForecastDetail();
    });
    instance.$store = this.$store;
    instance.$mount();
    var dialogTag = instance.$el;

    // setDOMContent()でコンポーネントをセットし、ポップアップの吹き出し内容として使用
    let anchorDirection =
      this.map.getCenter().lat < e.lngLat.lat &&
      this.map.getCenter().lng < e.lngLat.lng
        ? "top-right"
        : this.map.getCenter().lat < e.lngLat.lat &&
          this.map.getCenter().lng >= e.lngLat.lng
        ? "top-left"
        : this.map.getCenter().lat >= e.lngLat.lat &&
          this.map.getCenter().lng < e.lngLat.lng
        ? "bottom-right"
        : this.map.getCenter().lat >= e.lngLat.lat &&
          this.map.getCenter().lng >= e.lngLat.lng
        ? "bottom-left"
        : "center";
    var popup = new Mapbox.Popup({
      closeOnClick: true,
      closeButton: true,
      closeOnMove: true,
      anchor: anchorDirection,
      offset: 10,
      maxWidth: "800px",
    })
      .setLngLat([e.lngLat.lng, e.lngLat.lat])
      .setDOMContent(dialogTag)
      .addTo(this.map);
    this.windyPopup.push(popup);
  },

  /** Windyポップアップをクリアする */
  clearWindyPopup() {
    this.windyPopup.forEach((popup) => {
      popup.remove();
    });
    this.windyPopup.splice(0);
  },

  /** Windy詳細情報を表示する */
  showForecastDetail() {
    this.clearWindyPopup();
    this.forecastDetailActive = true;
  },

  async mounted() {
    let routerViewClass = document.getElementsByClassName("router-view");
    routerViewClass[0].style.setProperty("padding", "0.0rem", "important");

    this.$vs.loading({
      container: "#movement-map",
      scale: 0.6,
    });

    let pos = await LocalDbService.getDefaultPosition();
    this.mapStyleLocal = await LocalDbService.getMapStyle();
    Mapbox.accessToken = this.accessToken;
    Mapbox.prewarm();
    Mapbox.workerCount = this.getWorkerCount();
    Mapbox.maxParallelImageRequests = 10;
    let map = !this.isFreeAccount
      ? new Mapbox.Map({
          container: "movement-map",
          style: this.mapStyleLocal,
          center: pos.center,
          zoom: pos.zoom,
          doubleClickZoom: false,
          maxZoom: 18,
          attributionControl: false,
          localIdeographFontFamily: "'Noto Sans', sans-serif",
        })
      : new Mapbox.Map({
          // フリーアカウントの場合、center, zoom, minZoom, dragPan で制限をかける。
          container: "movement-map",
          style: this.mapStyleLocal,
          center: MAP_DEFAULT_POSITION.center,
          zoom: MAP_DEFAULT_POSITION.zoom,
          doubleClickZoom: false,
          dragPan: false,
          minZoom: pos.zoom,
          maxZoom: 18,
          attributionControl: false,
          localIdeographFontFamily: "'Noto Sans', sans-serif",
        });

    let scale = new Mapbox.ScaleControl({
      maxWidth: 80,
      unit: "imperial",
    });
    map.addControl(scale);
    let nav = new Mapbox.NavigationControl();
    map.addControl(nav, "bottom-left");

    let attr = new Mapbox.AttributionControl({
      customAttribution: [
        '<a href="https://www6.kaiho.mlit.go.jp/" target="_blank" aria-label="kaiho" role="listitem"><div class="attrib-kaiho-tooltip"><p>航路標識について</p><div class="aisea-text-12_400_black attrib-kaiho-tooltip-description">「海の安全情報」（海上保安庁）を加工して作成</div></div></a>' +
          " | " +
          '<a href="https://aidea.biz/" target="_blank" title="Aidea" aria-label="Aidea" role="listitem">© Aidea</a> ',
      ],
    });
    map.addControl(attr, "bottom-right");

    scale.setUnit("metric");
    this.map = map; // ここで紐付けないと setSubscribes() 時にエラー発生
    map.on("load", this.mapLoaded);
    map.on("movestart", this.mapMoveStart);
    map.on("moveend", this.mapMoveEnd);
    map.on("zoomstart", this.mapZoomStart);
    map.on("zoomend", this.mapZoomEnd);
    map.on("pitch", this.mapPitch);
    map.on("style.load", this.mapStyleLoad);

    // 沖波登録イベント
    let offingWavePointPointEvent = (e) => {
      if (this.isLimitOffingWavePoint) {
        this.$vs.dialog({
          color: "#EB5757",
          acceptText: "OK",
          title: `沖波ポイントエラー`,
          text: `沖波ポイントを追加できません。作成可能の上限（10個）を超えてます。`,
        });
        return;
      }
      let id = this.getOffingWavePointNextId;
      this.SET_DIALOG_OFFING_WAVE_POINT_INPUT_FORM({
        isShow: true,
        inputValues: {
          pointName: `Point${id}`,
          lng: e.lngLat.lng,
          lat: e.lngLat.lat,
        },
      });
    };

    if (this.getAddonFlag("GKMG_WEATHER_FORECAST")) {
      if (this.isIOS()) {
        let iosTimeout = null;
        let clearIosTimeout = () => {
          clearTimeout(iosTimeout);
        };

        map.on("touchstart", (e) => {
          if (e.originalEvent.touches.length > 1) {
            return;
          }
          iosTimeout = setTimeout(() => {
            offingWavePointPointEvent(e);
          }, 500);
        });
        map.on("touchend", clearIosTimeout);
        map.on("touchcancel", clearIosTimeout);
        map.on("touchmove", clearIosTimeout);
        map.on("pointerdrag", clearIosTimeout);
        map.on("pointermove", clearIosTimeout);
        map.on("moveend", clearIosTimeout);
        map.on("gesturestart", clearIosTimeout);
        map.on("gesturechange", clearIosTimeout);
        map.on("gestureend", clearIosTimeout);
      } else {
        map.on("contextmenu", (e) => {
          offingWavePointPointEvent(e);
        });
      }
    }

    //this.afterAdjustDom();
    this.toggleClassMapCtrls();
  },
  async created() {
    // 並列処理で実行する関数
    const functionArray = [];
    // アドオンがtrueの場合はsnapshot実行
    if (this.getAddonFlag("GKMG_PRIVATE_PLOT")) {
      functionArray.push(this.onSnapshotPrivatePlots());
      this.intervalIdPrivatePlot = setInterval(() => {
        this.createPrivatePlotFeatures(this.privatePlots);
      }, 60000);
    }
    if (this.getAddonFlag("GKMG_ANCHOR_MANAGEMENT")) {
      const user = await AuthService.getUser();
      const enterpriseId = user.id;
      functionArray.push(this.onSnapshotAnchors(enterpriseId));
    }
    if (this.getAddonFlag("GKMG_BASE_STATION")) {
      functionArray.push(this.subscribeEquipmentSeaRoutes());
      functionArray.push(this.subscribeEquipmentBaseStations());
      functionArray.push(this.subscribeEquipmentVessels());
      functionArray.push(this.subscribeEquipmentCategories());
      functionArray.push(this.subscribeEquipmentDepartureWharfs());
      functionArray.push(this.subscribeEquipmentDestinations());
      functionArray.push(this.subscribeEquipmentTypes());
    }
    await Promise.all(functionArray);
    const webWorker = this.getAddonFlag("GKMG_AIS_FOR_SIGNAL")
      ? new WebWorkerForFetchVesselGeometryForSignal()
      : new WebWorkerForFetchVesselGeometry();
    webWorker.addEventListener("message", async (e) => {
      await this.setVesselGeometryToMapSources(e.data);
    });
    this.webWorker = webWorker;
    this.isDebug = await LocalDbService.getIsDebug();
  },
  beforeDestroy() {
    this.cleanUpVesselDetail();
    this.cleanUpPlotDetail();
    this.resetLiveMapState();
    this.$store.dispatch("enterprisePlot/resetPlotState");
    this.resetPrivatePlotState();
    this.resetVesselEquipmentBaseStationState();
    this.resetAnchorState();
    this.unsubscribeFireStore();
    this.storeUnsubscribe();
    // キャッシュクリア
    this.$store.dispatch("enterpriseMapVesselTarget/clear");
    // プライベートプロットのアドオンがtrueの場合はintervalを解放
    if (this.getAddonFlag("GKMG_PRIVATE_PLOT")) {
      clearInterval(this.intervalIdPrivatePlot);
    }

    this.destroyPolling();
    if (this.unsubscribes.length !== 0) {
      this.unsubscribes.forEach((unsubscribe) => unsubscribe());
      this.unsubscribes = [];
    }
  },
};
</script>

<style lang="scss">
body {
  -webkit-touch-callout: none !important;
  -webkit-user-select: none !important;
}

@import "src/assets/scss/aisea/variables";
@import "src/assets/scss/vuexy/variables";

.mapboxgl-ctrl-logo {
  display: none !important;
}

#enterprise-live-map {
  position: relative;

  .mapboxgl-canvas {
    cursor: crosshair;
  }

  .left-sidebar-details {
    position: absolute;
    z-index: 5;
    top: 30px;
    left: 10px;
    right: 0;
    bottom: 0;
    pointer-events: none;
  }

  #movement-map {
    width: 100vw;
    min-height: 100vh; /* Fallback */
    min-height: calc(var(--vh, 1vh) * 100);

    position: relative;

    #map-loading {
      position: absolute;
      right: 1rem;
      bottom: 1rem;
      width: 5rem;
      height: 5rem;
    }

    .vs-con-loading__container {
      background-color: transparent;
    }
  }

  .map-controls-overlay {
    position: absolute;
    right: 20px;
    bottom: 88px;
    z-index: 10;
    transition-delay: 0.3s;
    -webkit-transform: translate3d(0%, 0px, 0px);
    transform: translate3d(0%, 0px, 0px);
    visibility: visible;
    transition: all 0.4s ease 0s;
    -webkit-transition: all 0.4s ease 0s;

    @media screen and (max-width: $min-width-iphone-8) {
      right: 16px;
      bottom: 88px;
    }

    @media screen and (min-width: $max-width-iphone-8) and (max-height: $min-width-iphone-8) {
      bottom: 77px;
    }

    @media screen and (min-width: $min-width-iphone-11-pro) and (max-height: $min-width-iphone-8) {
      bottom: 77px;
    }

    @media screen and (min-width: $min-width-ipad-pro-11) {
      bottom: 108px;
    }

    &.is-not-open {
      -webkit-transform: translate3d(300px, 0px, 0px);
      transform: translate3d(300px, 0px, 0px);
      visibility: visible;
      transition: all 0.4s ease 0s;
      -webkit-transition: all 0.4s ease 0s;
    }

    &.weather-menu {
      @media screen and (max-width: $min-width-iphone-8) {
        right: 72px;
        bottom: 228px;
      }
    }
  }

  .map-overlay-metocean-guide {
    position: absolute;
    left: 16px;
    bottom: 20px;

    @media screen and (max-width: $min-width-iphone-8) {
      bottom: 195px;
    }

    @media screen and (min-width: $max-width-ipad-pro-11 + 1) {
      left: 130px;
    }

    img {
      filter: drop-shadow(0 0 4px black);
      @media screen and (max-width: $max-width-iphone-8) and (max-height: $min-width-iphone-8) {
        width: 140px;
      }

      @media screen and (max-width: $min-width-ipad-pro-11) and (min-height: $max-width-iphone-11-pro) {
        width: 190px;
      }
    }
  }

  .map-controls-si {
    z-index: 2;
  }

  .mapboxgl-ctrl-bottom-left {
    &.weather-menu {
      left: 16px;

      @media screen and (max-width: $max-width-iphone-11-pro) {
        top: 50%;
        transform: translateY(-50%);
        -webkit-transform: translateY(-50%);
        bottom: unset;
      }

      @media screen and (min-width: $min-width-ipad-pro-11) and (max-width: $max-width-ipad-pro-11) {
        bottom: 130px;
      }
    }
  }

  .mapboxgl-ctrl-bottom-right {
    position: fixed;
  }

  #map-controls-function {
    position: fixed;
    z-index: 3;
    bottom: 20px;
    right: 20px;

    @media screen and (max-width: $min-width-iphone-8) {
      right: 16px;
      bottom: 20px;
    }

    &.weather-menu {
      @media screen and (max-width: $min-width-iphone-8) {
        bottom: 170px;
      }
    }
  }

  .map-restriction-info {
    position: absolute;
    top: 20px;
    right: 90px;
    max-width: calc(100% - 110px);
    background-color: rgba($aisea-pure-white, 0.8);
    border-radius: 8px;

    .map-restriction-info-button {
      color: $aisea-blue;
      border: 2px solid $aisea-blue;
      padding: 0.4rem 1.2rem;
      white-space: nowrap;
    }
  }
}

.offing-wave-point-marker {
  height: 26px;
  width: 18px;
  background-size: 100%;
  background-image: url("../../../assets/images/weather/offing_wave_point.svg");
  cursor: pointer;
}

.offing-wave-point-marker-popup {
  .mapboxgl-popup-content {
    height: 30px;
    background: #eb5757;
    padding: 5px 10px 15px;

    span {
      color: #f3f3f3;
      font-weight: 500;
      font-size: 12px;
      line-height: 15px;
    }
  }

  .mapboxgl-popup-tip {
    border-top-color: #eb5757;
  }
}

.parentx-static {
  padding-top: 50px;
  max-height: 650px;
  height: calc(90vh - 10px);
  top: 30px;
  left: 10px;
  position: relative;
}

.attrib-kaiho-tooltip {
  position: relative;
  cursor: pointer;
  display: inline-block;
}

.attrib-kaiho-tooltip p {
  margin: 0;
  padding: 0;
}

.attrib-kaiho-tooltip-description {
  display: none;
  position: absolute;
  padding: 10px;
  line-height: 1.4em;
  border-radius: 6px;
  background: $aisea-white;
  width: 300px;
}

.attrib-kaiho-tooltip-description:before {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  border: 10px solid transparent;
  border-top: 10px solid $aisea-white;
  margin-left: -10px;
}

.attrib-kaiho-tooltip:hover .attrib-kaiho-tooltip-description {
  display: inline-block;
  top: -50px;
  left: -100px;
}
</style>
